<mat-sidenav-container #sidenavContainer autosize="true">
    <mat-sidenav-content style="display: flex; flex-direction: column">
        <div class="listMapContainer">

            <mat-list class="paginated" style="display: flex; flex-direction: column;">
                <!-- loadingInProgress and mediaQueryService is declared in PaginatedListComponent -->
                <!--        <loading-overlay *ngIf="!loadingInProgress">Chargement des articles</loading-overlay>-->
                <fe-loader *ngIf="loadingInProgress" loaderText="Chargement des articles"/>
                <no-data *ngIf="!loadingInProgress && tableDataSource.data.length < 1">Aucun projet disponible</no-data>

                <div class="articlesContainer" *ngIf="!loadingInProgress && tableDataSource.data.length > 0">
                    <app-projet-list-item *ngFor="let article of tableDataSource.data"/>
                </div>
            </mat-list>
            <!--      <google-map *ngIf="(apiLoaded | async) && (listStyle == 'listmap' || listStyle == 'map')">-->
<!--            <google-map *ngIf="(listStyle == 'listmap' || listStyle == 'map')"-->
<!--                        [center]="mapCenter"-->
<!--                        [zoom]="zoom"-->
<!--                        (mapClick)="mapClick()">-->

<!--                <map-marker-clusterer [calculator]="getClusterStyle" imagePath="https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclustererplus/images/m">-->
<!--                    <ng-container *ngFor="let marker of markers; let i = index">-->
<!--                        <map-marker #mapMarker="mapMarker" [options]="marker.markerOption" (mapClick)="openInfoWindow(mapMarker, infoWindow)"></map-marker>-->
<!--                        <map-info-window #infoWindow="mapInfoWindow">-->
<!--                            <div class="listDate greyColor map-modal-text">{{marker.data.publicationDate | date:'dd/LL/yyyy':'':locale}}</div>-->
<!--                            <div style="display: block;margin:10px;font-size: 14px;cursor: pointer;" class="listTitle map-modal-text" onclick="return false;" (click)="openReadingModalFromMarker(marker.data)">{{marker.data.title}}</div>-->
<!--                        </map-info-window>-->
<!--                    </ng-container>-->
<!--                </map-marker-clusterer>-->
<!--            </google-map>-->

        </div>
        <mat-paginator>
        </mat-paginator>
    </mat-sidenav-content>
    <mat-sidenav position="end" mode="side" opened class="right-side-bar" disableClose="true">
        <div class="rightBtnContainer">
            <fe-button
                       type="TERTIARY"
                       color="PRIMARY" bold="true" icon="true" [iconType]="IconType.menu_open"
                       text="Réduire" iconDirection="LEFT"
                       bigIcon="true" noUnderline="true"></fe-button>
        </div>
        <app-search-selected-criterions [type]="'business'" class="search-selected-criterions-container"
                                        criteresText="Filtrer les résultats" showPrecisions="true"/>
        <!--    <fe-loader *ngIf="loadingInProgress" isOverflowing="true"/>-->
        <!--        </div>-->
    </mat-sidenav>
</mat-sidenav-container>